<template>
  <ul class="pagination justify-content-center mb-0 my-3 pagination-sm gap-2">
    <li
      v-if="currentPage >= 1"
      class="page-item"
    >
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="paginate(currentPage - 1)"
      >
        {{ $t('message.back') }}
      </button>
    </li>
    <li v-if="hasNext">
      <span
        type="button"
        class="btn btn-sm btn-primary"
        @click="paginate(currentPage + 1)"
      >
        {{ $t('message.forward') }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'GfCustomShortPagination',
  props: {
    hasNext: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage() {
      return Number(this.$route?.query?.page) || 0;
    }
  },
  methods: {
    paginate(page) {
      this.$emit('change', page);
    }
  }
};
</script>
